export function isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}

export function mergeObjects(target, source) {
    if (!source) return target;

    const merged = { ...target };

    Object.keys(source).forEach((key) => {
        const sourceValue = source[key];
        const targetValue = merged[key];

        // 递归处理对象类型的值
        if (typeof sourceValue === "object" && sourceValue !== null && !Array.isArray(sourceValue)) {
            merged[key] = mergeObjects(targetValue || {}, sourceValue);
        }
        // 非对象类型沿用原逻辑
        else if (!Object.prototype.hasOwnProperty.call(merged, key)) {
            merged[key] = sourceValue;
        } else if (sourceValue !== "" && sourceValue !== null && sourceValue !== undefined) {
            merged[key] = sourceValue;
        }
    });

    return merged;
}

export function trimObject(source) {
    return (excludeKeys = []) => {
        const result = {};

        Object.entries(source).forEach(([key, value]) => {
            const shouldExclude = excludeKeys.includes(key);
            const isEmptyArray = Array.isArray(value) && value.length === 0;
            const isInvalid = value === undefined || value === null || value === "" || value === "all" || isEmptyArray;

            if (!shouldExclude && !isInvalid) {
                result[key] = value;
            }
        });

        return result;
    };
}
